/*
  batik: shipping choice in the Slide Cart drawer for carts with ready stock and pre-order items. Added 28 Sep 2026.

  When the cart has both a STOQ pre-order line (property _stoq_shopify_selling_plan_id) and a ready-stock line,
  the drawer shows two options above its Checkout button:
  - Ship together (default, no charge): cart attribute "Shipping preference" says so, no fee line in the cart.
  - Partial fulfilment: adds the fee product (window.batikSplitShipping.feeVariantId) once.
  If the cart stops being mixed, the fee line and the attribute are removed.

  The drawer is the Slide Cart app: a same-origin iframe (#kaktusc-widget). The app only redraws its lines
  and total when the drawer opens. After adding the fee line this script closes the drawer and the app reopens
  it by itself; after removing it the script closes the drawer (.kaktusc-cart__close) and reopens it with the
  header cart icon (#cart-icon-bubble).
  Loaded by snippets/batik-split-shipping.liquid.
*/
(function () {
  var config = window.batikSplitShipping || {};
  var feeId = Number(config.feeVariantId);
  if (!feeId) return;

  var ATTR = 'Shipping preference';
  var TOGETHER = 'Ship together when the pre-order is ready';
  var PARTIAL = 'Partial fulfilment: ready stock first, pre-order later (' + config.feeLabel + ')';
  var BOX_ID = 'batik-split-shipping';
  var STYLE = [
    '#' + BOX_ID + '{margin:0 0 12px;padding:12px 14px;background:#fdf1ef;border-left:3px solid #d0021b;border-radius:2px;font-size:13px;line-height:1.45;color:#333;text-align:left}',
    '#' + BOX_ID + ' .bss-title{margin:0 0 8px;font-weight:700;color:#d0021b}',
    '#' + BOX_ID + ' .bss-option{display:flex;gap:8px;align-items:flex-start;margin:6px 0 0;cursor:pointer}',
    '#' + BOX_ID + ' .bss-option input{margin:3px 0 0;flex-shrink:0;accent-color:#d0021b}',
    '#' + BOX_ID + ' .bss-note{display:block;color:#555}',
    '#' + BOX_ID + '.bss-busy{opacity:.6;pointer-events:none}',
    // The fee product has no photo: hide the empty image and show a parcel icon instead.
    '.kaktusc-cart__product-img img[src=""]{visibility:hidden}',
    '.kaktusc-cart__product-img:has(img[src=""]){background:#f9f3ed url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%238e705d%27 stroke-width=%271.5%27%3E%3Cpath d=%27M3 7h11v9H3zM14 10h4l3 3v3h-7z%27/%3E%3Ccircle cx=%277%27 cy=%2717.5%27 r=%271.8%27/%3E%3Ccircle cx=%2717%27 cy=%2717.5%27 r=%271.8%27/%3E%3C/svg%3E") center/45% no-repeat;border-radius:4px}'
  ].join('');

  var working = false;
  var drawerDoc = null;
  var timer = null;

  function asJson(res) { return res.json(); }
  function getCart() {
    return window.fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(asJson);
  }
  function post(url, body) {
    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(asJson);
  }
  function attrs(value) {
    var a = {};
    a[ATTR] = value;
    return { attributes: a };
  }

  function cartState(cart) {
    var preorder = false;
    var ready = false;
    var fee = null;
    (cart.items || []).forEach(function (item) {
      if (item.variant_id === feeId) {
        fee = item;
      } else if (item.properties && item.properties._stoq_shopify_selling_plan_id) {
        preorder = true;
      } else {
        ready = true;
      }
    });
    return { mixed: preorder && ready, fee: fee, choice: (cart.attributes || {})[ATTR] || '' };
  }

  // Bring the cart in line with the rules at the top.
  // Resolves with { cart, changed }, where changed means a cart line was added, removed or resized.
  function reconcile(cart) {
    var s = cartState(cart);
    if (!s.mixed) {
      var p = Promise.resolve();
      if (s.fee) p = p.then(function () { return post('/cart/change.js', { id: s.fee.key, quantity: 0 }); });
      if (s.choice) p = p.then(function () { return post('/cart/update.js', attrs('')); });
      if (!s.fee && !s.choice) return Promise.resolve({ cart: cart, changed: false });
      return p.then(getCart).then(function (c) { return { cart: c, changed: !!s.fee }; });
    }
    if (s.fee && s.fee.quantity !== 1) {
      return post('/cart/change.js', { id: s.fee.key, quantity: 1 }).then(getCart).then(function (c) {
        return { cart: c, changed: true };
      });
    }
    var wanted = s.fee ? PARTIAL : TOGETHER;
    if (s.choice !== wanted) {
      return post('/cart/update.js', attrs(wanted)).then(function (c) { return { cart: c, changed: false }; });
    }
    return Promise.resolve({ cart: cart, changed: false });
  }

  // The drawer app only redraws its lines and total when it opens. After an add it reopens the drawer by itself
  // (about 1.1 s later, only if the drawer is closed), so then just close it. After a removal, close and reopen it.
  function refreshDrawer(added) {
    var close = drawerDoc && drawerDoc.querySelector('.kaktusc-cart__close');
    if (!close) return;
    close.click();
    if (added) return;
    var icon = Array.prototype.find.call(document.querySelectorAll('#cart-icon-bubble, a[href$="/cart"]'), function (a) {
      return a.getBoundingClientRect().width > 0;
    });
    if (icon) reopenWhenClosed(icon, 0);
  }

  function drawerIsOpen() {
    var frame = document.getElementById('kaktusc-widget');
    return !!frame && frame.getBoundingClientRect().width > 0;
  }

  // Wait until the close animation has finished (the app ignores clicks before that), open it, and try once more if needed.
  function reopenWhenClosed(icon, tries) {
    if (drawerIsOpen()) {
      if (tries < 20) setTimeout(function () { reopenWhenClosed(icon, tries + 1); }, 150);
      return;
    }
    setTimeout(function () {
      icon.click();
      setTimeout(function () { if (!drawerIsOpen()) icon.click(); }, 1500);
    }, 300);
  }

  function choose(value) {
    if (working) return;
    working = true;
    draw(null);
    getCart()
      .then(function (cart) {
        var s = cartState(cart);
        var p = post('/cart/update.js', attrs(value === 'partial' ? PARTIAL : TOGETHER));
        if (value === 'partial' && !s.fee) {
          p = p.then(function () { return post('/cart/add.js', { items: [{ id: feeId, quantity: 1 }] }); })
            .then(function () { refreshDrawer(true); });
        }
        if (value !== 'partial' && s.fee) {
          p = p.then(function () { return post('/cart/change.js', { id: s.fee.key, quantity: 0 }); })
            .then(function () { refreshDrawer(false); });
        }
        return p;
      })
      .catch(function () {})
      .then(function () {
        working = false;
        schedule();
      });
  }

  function draw(state) {
    var doc = drawerDoc;
    if (!doc || !doc.body) return;
    var anchor = doc.querySelector('.kaktusc-cart__checkout-wrap');
    var box = doc.getElementById(BOX_ID);
    if (state && (!state.mixed || !anchor)) {
      if (box) box.remove();
      return;
    }
    if (!anchor) return;
    if (!doc.getElementById(BOX_ID + '-style')) {
      var style = doc.createElement('style');
      style.id = BOX_ID + '-style';
      style.textContent = STYLE;
      (doc.head || doc.body).appendChild(style);
    }
    if (!box) {
      box = doc.createElement('div');
      box.id = BOX_ID;
      box.innerHTML =
        '<p class="bss-title">Your cart has ready-stock and pre-order items. How should we ship them?</p>' +
        '<label class="bss-option"><input type="radio" name="bss-choice" value="together">' +
        '<span><strong>Ship together</strong> (no extra charge)' +
        '<span class="bss-note">Everything ships in one parcel once the pre-order items are ready.</span></span></label>' +
        '<label class="bss-option"><input type="radio" name="bss-choice" value="partial">' +
        '<span><strong>Partial fulfilment</strong> (+' + config.feeLabel + ')' +
        '<span class="bss-note">Ready-stock items ship first. All pre-order items ship together in one later shipment.</span></span></label>';
      box.addEventListener('change', function (event) {
        if (event.target && event.target.name === 'bss-choice') choose(event.target.value);
      });
      anchor.parentNode.insertBefore(box, anchor);
    }
    box.classList.toggle('bss-busy', working);
    if (state) {
      var want = state.fee ? 'partial' : 'together';
      box.querySelectorAll('input[name="bss-choice"]').forEach(function (input) {
        input.checked = input.value === want;
      });
    }
  }

  function refresh() {
    if (working || !drawerDoc || !drawerDoc.querySelector('.kaktusc-cart__checkout-wrap')) return;
    getCart()
      .then(reconcile)
      .then(function (result) {
        if (result.changed) refreshDrawer(false);
        draw(cartState(result.cart));
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 350);
  }

  // The drawer iframe is created by the app, so look for it and watch it once it exists.
  function hook() {
    var frame = document.getElementById('kaktusc-widget');
    var doc = null;
    try { doc = frame && frame.contentDocument; } catch (e) { doc = null; }
    if (!doc || !doc.body || doc === drawerDoc) return;
    drawerDoc = doc;
    new MutationObserver(function (records) {
      var ours = records.every(function (r) {
        var node = r.target;
        return node && node.closest && node.closest('#' + BOX_ID);
      });
      if (!ours) schedule();
    }).observe(doc.body, { childList: true, subtree: true });
    schedule();
  }

  setInterval(hook, 1000);
  hook();
})();
